import { useLang } from "../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;

  return (
    <div
      data-testid="marquee"
      className="marquee overflow-hidden border-y border-line bg-ink-900/60 py-6"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center gap-10 pr-10">
            {items.map((item, i) => (
              <span key={i} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-display text-2xl font-bold tracking-tight text-white/80">
                  {item}
                </span>
                <span className="inline-block h-2 w-2 rotate-45 bg-volt/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
